/**
 =========================================================
 * Material Dashboard 2 React - v2.2.0
 =========================================================

 * Product Page: https://www.creative-tim.com/product/material-dashboard-react
 * Copyright 2023 Creative Tim (https://www.creative-tim.com)

 Coded by www.creative-tim.com

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
 */

import * as React from 'react';

// @mui material components
import Grid from "@mui/material/Grid";
import { useEffect, useState } from "react";
import Icon from "@mui/material/Icon";
import MDButton from "../../components/MDButton";
import DataTable from "../../examples/Tables/DataTable";
import useApi from "../../components/Utils/api";
import data from "../dashboard/components/Projects/data";
import MDBox from "../../components/MDBox";
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar";
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import Dialog from "@mui/material/Dialog";
import Button from "@mui/material/Button";
import DialogActions from "@mui/material/DialogActions";
import Typography from "@mui/material/Typography";
import toast from "utils/toast";
import Papa from 'papaparse';

function ResetImei() {
  const [terminals, setTerminals] = useState([]);
  const [terminal, setTerminal] = useState({});
  const { resetTerminalTablecolumns } = data();
  const [openImeiDialog, setOpenImeiDialog] = useState(false);
  const [openPasswordDialog, setOpenPasswordDialog] = useState(false);
  const api = useApi();
  const generateCSV = () => {
    if (terminals.length === 0) {
      return '';
    }

    const headers = resetTerminalTablecolumns
      .filter(column => column.Header !== "Action")
      .map(column => column.Header);

    const terminalsWithoutAction = terminals.map(item => {
      return resetTerminalTablecolumns
        .filter(column => column.Header !== "Action")
        .map(column => {
          const accessor = column.accessor;
          const value = typeof accessor === 'function' ? accessor(item) : item[accessor];
          return value;
        });
    });

    const csvData = [headers, ...terminalsWithoutAction];

    const csv = Papa.unparse(csvData, {
      quotes: true,
    });

    return csv;
  };

  const handleDownloadCSV = () => {
    if (terminals.length === 0) {
      toast.error("No records found to download.");
      return;
    }

    const csvData = generateCSV();

    const currentDate = new Date().toISOString().slice(0, 10);
    const currentTime = new Date().toLocaleTimeString().replace(/:/g, '-');
    const dateTimeString = `${currentDate}_${currentTime}`;

    const fileName = `ResetImei_${dateTimeString}.csv`;

    const blob = new Blob([csvData], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };
  useEffect(() => {
    getAllTerminals();
  }, []);
    const resetImei = (item) => {
        setOpenImeiDialog(true);
        setTerminal(item);
    }
    const getAllTerminals = () => {
        const data = {
          msisdn: '',
          mid: ''
        }
        api.post("/terminal/browse", data)
            .then(response => {
              if(response.data.statusCodeValue === 200) {
                const modifiedData = response.data.body.map(item => {
                  const action = (
                      <MDBox display="flex" alignItems="center" lineHeight={1}>
                        <Icon title="Reset IMEI" fontSize="small" style={{cursor : 'pointer', marginRight: '5px'}} onClick={() => resetImei(item)}>lock_reset</Icon>
                      </MDBox>
                  );
                  return { ...item, action };
                });
                setTerminals(modifiedData);
              }
              console.log(response)
            })
            .catch(error => {
              console.log(error)
            })
    }

    const handleImeiResetSubmit = () => {
        const data = {
            tid: terminal.tid
        }
        api.post("/utils/resetimei", data)
            .then(response => {
                if (response.data.statusCodeValue === 200) {
                    setOpenImeiDialog(false);
                    setTerminal({});
                    getAllTerminals();
                    toast.success(response.data.body);
                }
            })
            .catch(error => {
                if(error.response.data.body){
                    toast.error(error.response.data.body);
                }

            })
    }

    return (
      <DashboardLayout>
        <DashboardNavbar />
        <MDBox mt={6} mb={3}>
            <Grid container spacing={3} justifyContent="center">
                <Grid item xs={12} lg={12}>
                <MDButton variant="gradient" onClick={handleDownloadCSV} color="info" style={{marginRight: "24px", marginBottom: "12px"}}>
                  Export
              </MDButton>
                    <DataTable
                        table={{ columns : resetTerminalTablecolumns, rows : terminals }}
                        showTotalEntries={true}
                        isSorted={true}
                        noEndBorder
                        entriesPerPage={true}
                        hideExpandColumn={true} 
                        canSearch={true}
                    />
                </Grid>
            </Grid>
        </MDBox>
      <Dialog disableEscapeKeyDown open={openImeiDialog} onClose={() => setOpenImeiDialog(true)}>
          <DialogTitle>Reset Terminal IMEI</DialogTitle>
          <DialogContent>
              <Typography fontSize="medium">Do you really want to reset the IMEI for terminal id <Typography fontSize="medium" fontWeight="bold">{terminal?.tid}</Typography></Typography>
          </DialogContent>
          <DialogActions>
              <Button onClick={() => {
                setOpenImeiDialog(false);
                setTerminal({});
              }
              }>Cancel</Button>
              <Button onClick={handleImeiResetSubmit}>Ok</Button>
          </DialogActions>
      </Dialog>
      </DashboardLayout>
  );
}

export default ResetImei;
